
<template>
  <div class="dialogAddBankInfo">
    <!-- 添加付款信息 -->
    <el-dialog title="确认退款信息" append-to-body :visible="dialogVisible" @close="closeDialog">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="170px" >
        <el-form-item label="银行类型" prop="paymentCardType">
          <el-radio-group v-model="form.paymentCardType" :disabled="form.paymentCardType!=null||form.paymentCardType!=''" @change="changeCardType">
            <el-radio :label="0">对公账号</el-radio>
            <el-radio :label="1">对私账号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="银行名称:" prop="paymentBankCode">
          <span v-if="form.paymentBankName">{{form.paymentBankName}}</span>
          <el-select v-else size="small" filterable :filter-method="selectBankList" :loading="loading" v-model="form.paymentBankCode" placeholder="请输入关键词" clearable>
            <el-option v-for="val in options" :key="val.bankCode" :label="val.bankShortName" :value="val.bankCode" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="汇款户名">
          <span>{{form.paymentUserName}}</span>
        </el-form-item>
        <el-form-item label="银行账号">
          <span>{{form.paymentBankNo}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryBankTypeSet,updatePayment} from "~/api/paymentSet";

export default {
  props:['showDialog','info'],
  data(){
    return {
      dialogVisible: false,
      btnloading:false,
      form: {
        outSn: null,
        paymentCardType:0,
        paymentBankCode: null,
        paymentBankName: null,        
        paymentUserName: null,
        paymentBankNo: null,
      },
      rules:{
        paymentCardType: [
          { required: true, message: '请选择银行类型', trigger: 'change' }
        ],
        paymentBankCode: [
          { required: true, message: '请选择付款银行', trigger: 'change' }
        ],
      },
      options:[],
      loading: false
    }
  },
  watch: {
    showDialog(value) {
      this.dialogVisible = value;
      if (value) {
        // this.btnloading = false;
      }
    },
    info: {
      handler: function (val) {
        console.log(val,'info')
        if(val){
          this.setInit(val);
          this.selectBankList(val.paymentBankName);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods:{
    changeCardType(val){

    },
    setInit(info){
      this.form.outSn = info.outSn;
      this.form.paymentCardType = info.paymentCardType;
      this.form.paymentBankCode = info.paymentBankCode;
      this.form.paymentBankName = info.paymentBankName;
      this.form.paymentUserName = info.paymentUserName;
      this.form.paymentBankNo = info.paymentBankNo;
    },  
    selectBankList(bankName){
      if (bankName) {
        this.loading = true;
        queryBankTypeSet({bankName}).then(res=>{
          this.loading = false;
          this.options = res
        }).catch(err=>{
          this.options = [];
          this.loading = false;
        })
      } else {
        this.options = [];
        this.loading = false;
      }
      
    },
    submit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.saveBank()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveBank(){
      updatePayment(this.form).then(res=>{
        this.$emit('change',this.info)
        this.closeDialog()
      }).catch(err=>{
        this.closeDialog()
      })
    },
    closeDialog(){
      this.dialogVisible = false
      this.form = {
        outSn: null,
        paymentCardType:0,
        paymentBankCode: null,
        paymentBankName: null,
        paymentUserName: null,
        paymentBankNo: null,
      }
      this.$emit('close')
    },
  }
}
</script>

<style lang="less">
  .dialogAddBankInfo{
    .el-select .el-input__inner {
      padding-right: 30px;
    }
  }
   
</style>